import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  Application,
  ListRequestOfApplicationsByOrganizationUsersFilter,
  ListResponseOfApplication,
} from "services/KnowfullyAdminClient";

interface SelectOrganizationApplicationProps
  extends Omit<
    AutocompleteWithQueryProps<Application>,
    "fetchedData" | "failMessage" | "labelField"
  > {
  organizationId: string;
}

const SelectOrganizationApplication = ({
  organizationId,
  ...props
}: SelectOrganizationApplicationProps) => {
  const { formatMessage: t } = useIntl();
  const { applicationService } = useGlobalContext();

  const fetchedData = useQuery<ListResponseOfApplication>(
    ["applicationService.getApplicationsByOrganizationUsers", organizationId],
    () =>
      applicationService.getApplicationsByOrganizationUsers(
        ListRequestOfApplicationsByOrganizationUsersFilter.fromJS({
          sortField: "name",
          parameters: {
            organizationId,
          },
        })
      ),
    { enabled: !!organizationId }
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedData}
      failMessage={t({ id: "selectApplicationFetchFailed" })}
    />
  );
};

export default SelectOrganizationApplication;
